// extracted by mini-css-extract-plugin
export default {"accordion":"Accordion_accordion__40VH3","accordionItem":"Accordion_accordionItem__y7O6m","collapsed":"Accordion_collapsed__rOfXA","title":"Accordion_title__O5wb5"};